module.exports = "<input type=\"text\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-table/src/browser/filters/text.html
// module id = 2153
// module chunks = 2